var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ScaleLoader',{staticStyle:{"min-width":"50px"},attrs:{"loading":_vm.loading,"color":_vm.color,"customclass":_vm.customclass}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }